import { SubscriptionPaymentRecurrence } from "./SubscriptionPaymentRecurrence";

export enum BarionPaymentStatus {
    Unprepared = "Unprepared",
    Prepared = "Prepared",
    Started = "Started",
    InProgress = "InProgress",
    Waiting = "Waiting",
    Reserved = "Reserved",
    Authorized = "Authorized",
    Canceled = "Canceled",
    Succeded = "Succeeded",
    Failed = "Failed",
    PartiallySucceeded = "PartiallySucceeded",
    Expired = "Expired",
}

export enum PaymentType {
    SUBSCRIPTION_START = "SUBSCRIPTION_START",
    RECURRING_PAYMENT = "RECURRING_PAYMENT",
}

/*
        "id": 4,
        "uuid": "e9881dc4-a875-454f-8c2e-5bb521cb1c28",
        "amount": "3175.00",
        "barionId": "916239e12678f0118c1c001dd8b71cc4",
        "createdAt": "2025-08-13T09:21:24.000Z",
        "updatedAt": "2025-08-13T09:21:24.000Z",
        "status": "Prepared",
        "paymentType": "SUBSCRIPTION_START",
        "failReason": null,
        "billingoId": null,
        "paymentRecurrenceId": 6
*/

export interface SerializedSubscriptionPayment {
    id: number;
    uuid: string;
    amount: number;
    barionId: string;
    createdAt: string; // ISO date string
    updatedAt: string; // ISO date string
    status: BarionPaymentStatus;
    paymentType: PaymentType;
    failReason?: string | null;
    billingoId?: number | null;
    paymentRecurrenceId: number;
    paymentRecurrence?: SubscriptionPaymentRecurrence; // Optional, if you want to include the recurrence details
}

export interface SubscriptionPayment {
    id: number;
    uuid: string;
    amount: number;
    barionId: string;
    createdAt: Date; // ISO date string
    updatedAt: Date; // ISO date string
    status: BarionPaymentStatus;
    paymentType: PaymentType;
    failReason?: string | null;
    billingoId?: number | null;
    paymentRecurrenceId: number;
    paymentRecurrence?: SubscriptionPaymentRecurrence; // Optional, if you want to include the recurrence details
}

export function deserializeSubscriptionPayment(data: SerializedSubscriptionPayment): SubscriptionPayment {
    return {
        id: data.id,
        uuid: data.uuid,
        amount: data.amount,
        barionId: data.barionId,
        createdAt: new Date(data.createdAt),
        updatedAt: new Date(data.updatedAt),
        status: data.status,
        paymentType: data.paymentType,
        failReason: data.failReason || null,
        billingoId: data.billingoId || null,
        paymentRecurrenceId: data.paymentRecurrenceId,
        paymentRecurrence: data.paymentRecurrence != null ? data.paymentRecurrence : undefined,
    };
}